import * as React from "react";
import { Text } from "@grandvisionhq/elements";
import { Toggletip } from "@grandvisionhq/lib-visuals";
/* empty css                          */
const FromPriceDisclaimers = ({
  includesLabel,
  excludesLabel,
  excludesTooltipLabel
}) => /* @__PURE__ */ React.createElement(React.Fragment, null, includesLabel && /* @__PURE__ */ React.createElement(Text, { variant: "caption", color: "text-secondary" }, includesLabel), excludesLabel && /* @__PURE__ */ React.createElement(Text, { variant: "caption", color: "text-secondary", className: "from-price-disclaimer-excludes" }, excludesLabel, excludesTooltipLabel && /* @__PURE__ */ React.createElement(Toggletip, { message: excludesTooltipLabel })));
export {
  FromPriceDisclaimers
};
//# sourceMappingURL=FromPriceDisclaimers.js.map
